import splitNames, { splitDelegated } from './_splitnames.js';
import checkObjectType from '../_helpers/checkobjecttype.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import forOwn from '../_helpers/forown.js';
import forEach from '../_helpers/foreach.js';
import addListener from './_addlistener.js';
import delegateListener from './_delegatelistener/index.js';
export default function on(object, givenNames, callback, triggerOnInit, context) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    context = triggerOnInit;
    triggerOnInit = callback;
    callback = givenNames;
    givenNames = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'on');
  }
  var isNamesVarArray = Array.isArray(givenNames);
  // allow to pass name-handler object
  if (givenNames && typeof givenNames === 'object' && !isNamesVarArray) {
    forOwn(givenNames, function (namesObjCallback, namesObjName) {
      return on(object, namesObjName, namesObjCallback, callback, triggerOnInit);
    });
    return object;
  }
  if (typeof givenNames !== 'string' && !isNamesVarArray) {
    throw matreshkaError('on:names_type', {
      names: givenNames
    });
  }
  // split by spaces
  // TODO: Array of names passed to on method is non-documented feature
  var names = isNamesVarArray ? givenNames : splitNames(givenNames);
  // flip triggerOnInit and context when triggerOnInit is not boolean
  if (typeof triggerOnInit !== 'boolean' && typeof triggerOnInit !== 'undefined') {
    var _ref = [triggerOnInit, context];
    context = _ref[0];
    triggerOnInit = _ref[1];
  }
  forEach(names, function (name) {
    // "user" tells off() with no args which listeners to remove (it keeps the framework's own)
    var info = {
      user: true
    };
    var delegated = splitDelegated(name);
    if (delegated) {
      // if @ exists in event name then this is delegated event
      var path = delegated[0],
        delegatedName = delegated[1];
      delegateListener(object, path, delegatedName, callback, context || object, info);
    } else {
      // if not, this is simple event
      addListener(object, name, callback, context, info);
    }
  });
  // call callback immediatelly if triggerOnInit is true
  if (triggerOnInit === true) {
    callback.call(context || object, {
      triggerOnInit: triggerOnInit
    });
  }
  return object;
}